import React from "react";
import styled from "styled-components";
import { LinkButton } from "./Button";

export interface FooterProps {
  items: Array<any>;
  footerImage: any;
  voText: string;
  voUrl: string;
}

const FixedDiv = styled.div`
  left: 0;
  bottom: 0;
  width: 100%;
  text-align: center;
  background-color: #f4f4f4;
  border-top: solid 1px #dedede;
`;

const Footer = styled.div`
  padding: 2rem 0rem 1rem 0rem;
  color: #898585;
`;

const ItemsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center; 
  @media (max-width: 768px) {
    flex-wrap:wrap;
    margin: 0;
    padding: 0;
  }
`;

const FooterItem = styled.span<{ odd: boolean }>`
  margin-right: 1rem;
  color: #898585;
  text-align: center;
  font-size: 14px!important;
  border-right: ${(props) =>
    props.odd ? "1px solid rgb(155, 155, 155)" : "none"};
  border-left: ${(props) =>
    props.odd ? "1px solid rgb(155, 155, 155)" : "none"};
  padding-right: ${(props) => (props.odd ? "1rem" : "0")};
  padding-left: ${(props) => (props.odd ? "1rem" : "0")};
  @media (max-width: 768px) {
    padding: 0rem 0.2rem;
    margin-right:0.2rem;
    border-left: ${(props) =>
    props.odd ? "1px solid rgb(155, 155, 155) !important" : "none"};
    border-right: none !important;
    :nth-last-child(1) {
     font-weight: 600;
    }
  }
`;

const FooterImage = styled.div`
  display:none;
  @media (max-width: 768px) {
    display:block;
    img{
      width:6rem;
    }
  }
`;

const VirtualOffice = styled.div`
  display:none;
  @media (max-width: 768px) {
    padding:1rem;
    display:block;
  }
`;

const FooterLink = styled.a`
  text-decoration: none;
  cursor: pointer;
`;

const FooterComp: React.FC<FooterProps> = ({ items, footerImage, voText, voUrl }) => (
  <FixedDiv>
    <Footer>
      <FooterImage ><img src={footerImage} /></FooterImage>
      <VirtualOffice >
        <LinkButton icon="external-link" text={voText} linkUrl={voUrl} />
      </VirtualOffice>
      <ItemsContainer>
        {items.map((item, index) => {
          return (
            <FooterItem key={index} odd={index % 2 !== 0}>
              {item.url ? (
                <FooterLink href={item.url}>
                  {item.label}
                </FooterLink>
              ) : (
                item.label
              )}
            </FooterItem>
          );
        })}
      </ItemsContainer>
    </Footer>
  </FixedDiv>
);

export default FooterComp;
